import { Component, inject, OnInit } from '@angular/core';
import { IFooterButtonOptions } from 'fas-services';
import { MOCK_DATA } from '../../shared/helpers/mocked-data';
import { DialogService } from '../../shared/services/dialog.service';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrl: './transactions.component.scss'
})
export class TransactionsComponent implements OnInit{

  private _dialogService = inject(DialogService);

  public ID_OSK = 'ID_OSK';
  public oskSelected: any[] = [];
  public oskIndex!:any
  public oskList!:any
  public osk!:any

  public oskFooterBtn: IFooterButtonOptions ={
    buttonLabel:'Usuń zaznaczone',
    buttonIcon: 'pi pi-trash',
    buttonFunction: this.test.bind(this)
  }

  ngOnInit(): void {
    this.oskList = MOCK_DATA;
  }

  public oskColumns = [
    {
      field: 'subName',
      header: 'Data',
      contentClass: 'text-sm',
      sortable:true,
    },
    {
      field: 'messageEmail',
      header: 'Wartość',
      contentClass: 'text-sm',
      sortable:true,
    },
    {
      field: 'actions',
      header: 'Akcje',
      columnClass: 'flex align-items-center gap-2',
      actions: [
        {
          label: 'Generuj fakturę',
          buttonClass: 'primary-button appear',
          callback: this.test.bind(this),
        },
        {
          label: '',
          tooltip: 'Usuń',
          buttonClass:
            'pi pi-trash cursor-pointer text-center appear transparent-button',
        },
      ],
    },
  ]

  test(){
    console.log('test')
  }

  openDetails(osk: any, oskIndex: number) {
    this.osk = { ...osk };
    this.oskIndex = oskIndex;
    this.openDialog(this.ID_OSK)
  }

  openDialog(id: string): void {
    this._dialogService.openDialog(id);
  }

}